import RepaymentReport from "../../../jsx/components/Dashboard/RepaymentReport/RepaymentReport";

const RepaymentReportsWrapper = () => {
  return <RepaymentReport />;
};

export default constore(RepaymentReportsWrapper);
